import ParkingCard from '@components/ParkingCard/ParkingCard.component'
import { DateTime } from 'luxon'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SpecificCarpayCard } from '../CarpayOrderCard.component'
import { CardExtraWarningInfo } from '../CarpayOrderCard.style'
import CarpayOrderCardContent from '../CarpayOrderCardContent.component'
import CarpayOrderCardHeader from '../CarpayOrderCardHeader.component'

const EnforcedCarpayOrderCard = ({
    order,
    priceToBePaid,
    discount,
    isLast,
    disabled,
    onClick,
    currency
}: SpecificCarpayCard) => {
    const { t } = useTranslation()

    return (
        <ParkingCard isLast={isLast} disabled={disabled} onClick={onClick}>
            <CarpayOrderCardHeader
                text={DateTime.fromISO(order.start_date).toFormat('dd.MM.yyyy')}
                badgeText={t('carpay.orderStatuses.unpaidEnforceable')}
                badgeVariant="negative"
            />

            <CarpayOrderCardContent
                currency={currency}
                title={t('carpay.orderCard.price')}
                price={priceToBePaid}
                discount={discount}
            />

            <CardExtraWarningInfo>{t('carpay.orderCard.additionalFees')}</CardExtraWarningInfo>
        </ParkingCard>
    )
}
export default EnforcedCarpayOrderCard
